import {
  ADMIN_CHAT_USERS_REQUEST,
  ADMIN_CHAT_USERS_SUCCESS,
  ADMIN_CHAT_USERS_FAIL,
  ADMIN_CHAT_SEND_REQUEST,
  ADMIN_CHAT_SEND_SUCCESS,
  ADMIN_CHAT_SEND_FAIL,
  ADMIN_CHAT_RECEIVE_REQUEST,
  ADMIN_CHAT_RECEIVE_SUCCESS,
  ADMIN_CHAT_RECEIVE_FAIL,
} from "./chatTypes";

if (typeof window !== "undefined") {
  var userInfoFromStorage = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
}
export const chatReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_CHAT_USERS_REQUEST ||
      ADMIN_CHAT_SEND_REQUEST ||
      ADMIN_CHAT_RECEIVE_REQUEST:
      return { ...state, loading: true, users: [], chat: {} };
    case ADMIN_CHAT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.filter(
          (obj) => obj._id !== userInfoFromStorage.id
        ),
      };
    case ADMIN_CHAT_SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        // users: action.payload.filter(
        //   (obj) => obj._id !== userInfoFromStorage.id
        // ),
        success: true,
      };
    case ADMIN_CHAT_RECEIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        conversation: action.payload._id,
        messages: action.payload.messages,
      };
    case ADMIN_CHAT_USERS_FAIL ||
      ADMIN_CHAT_SEND_FAIL ||
      ADMIN_CHAT_RECEIVE_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
